import { z } from 'zod';

export const HOST_HEALTH_SCHEMA_VERSION = 1 as const;

export const hostHealthStateSchema = z.enum([
  'healthy', 'degraded', 'recovering', 'offline', 'maintenance',
]);
export type HostHealthState = z.infer<typeof hostHealthStateSchema>;

export const componentHealthStateSchema = z.enum([
  'running', 'stopped', 'unreachable', 'starting', 'failed',
]);
export type ComponentHealthState = z.infer<typeof componentHealthStateSchema>;

export const recoveryIntentSchema = z.enum([
  'none', 'planned-stop', 'update', 'reboot', 'teardown',
]);
export type RecoveryIntent = z.infer<typeof recoveryIntentSchema>;

export const hostHealthSnapshotSchema = z.object({
  schemaVersion: z.literal(HOST_HEALTH_SCHEMA_VERSION),
  machineId: z.string().min(1).max(256),
  hostState: hostHealthStateSchema,
  recoveryIntent: recoveryIntentSchema,
  components: z.record(z.string().min(1).max(64), componentHealthStateSchema),
  buildVersion: z.string().min(1).max(128),
  recoveryProtocolVersion: z.literal(1).optional(),
  recoveryAttemptId: z.string().min(1).max(128).optional(),
  lastFailureCode: z.string().min(1).max(128).optional(),
  observedAtUtc: z.string().datetime({ offset: true }),
}).strict();
export type HostHealthSnapshot = z.infer<typeof hostHealthSnapshotSchema>;

export const recoveryEventOutcomeSchema = z.enum(['started', 'succeeded', 'failed', 'deferred']);
export const recoveryEventSchema = z.object({
  schemaVersion: z.literal(HOST_HEALTH_SCHEMA_VERSION),
  attemptId: z.string().min(1).max(128),
  stage: z.string().min(1).max(128),
  outcome: recoveryEventOutcomeSchema,
  reasonCode: z.string().min(1).max(128).optional(),
  observedAtUtc: z.string().datetime({ offset: true }),
}).strict();
export type RecoveryEvent = z.infer<typeof recoveryEventSchema>;
